import MicroModal from 'micromodal';
import { eventBus } from '@weareduet/plugins';
import { capture, release } from '@/utils/scrollLock';

function Modal() {
	// MicroModal only removes `is-open` on an `animationend` from `.modal`.
	// Under prefers-reduced-motion:reduce no close animation ever runs, so if
	// awaitCloseAnimation stays true the modal never closes (stays is-open,
	// display:flex, blocks the page) and cannot reopen. Build the config fresh
	// on every call so a preference change mid-session is honoured too.
	const buildConfig = () => ({
		onShow: () => capture(),
		onClose: () => release(),
		awaitCloseAnimation: !window.matchMedia('(prefers-reduced-motion: reduce)')
			.matches,
	});

	MicroModal.init(buildConfig());

	const openModal = id => {
		MicroModal.show(id, buildConfig());
	};

	eventBus.on('modal:open', openModal);

	return () => {
		eventBus.off('modal:open', openModal);
	};
}

export default Modal;

/*
 *		Safari Bug
 *		https://github.com/ghosh/Micromodal/issues/496
 *		BEWARE: Safari is a piece of Shit; if you're trying `onShow: (modal, target, event) => {...` the `target` might not work, and you need to do `event.target` and maybe buble that up to the actual target. Urgh
 */
